import { render, staticRenderFns } from "./EstatusVehiculo.vue?vue&type=template&id=a62bd1f8"
import script from "./EstatusVehiculo.vue?vue&type=script&lang=js"
export * from "./EstatusVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports